module.exports = __webpack_public_path__ + "static/media/carry-04-1.f2ab6371.png";